import { createSelector } from 'reselect';

import { TState } from '~/src/store';

/** Есть ли добавленное оборудование (не учитывает обязательное)
 * @param state {TState} - стор
 */
export const isHaveSelectedProducts = createSelector(
    [
        (state: TState) => state.fullBuy.products,
    ],
    (products) => !!products?.some(product => product.quantity > 0),
);
